export default {
    animation: Object,
    autoBind: Boolean,
    cascadeFrom: String,
    cascadeFromField: String,
    cascadeFromParentField: String,
    columns: Array,
    clearButton: Boolean,
    dataSource: Object | Array,
    dataTextField: String,
    dataValueField: String,
    dropDownWidth: String | Number,
    delay: Number,
    enable: Boolean,
    enforceMinLength: Boolean,
    filter: String,
    filterFields: Array,
    fixedGroupTemplate: String | Function,
    footerTemplate: String | Function,
    groupTemplate: String | Function,
    height: Number,
    highlightFirst: Boolean,
    ignoreCase: Boolean,
    index: Number,
    minLength: Number,
    noDataTemplate: String | Function,
    placeholder: String,
    popup: Object,
    suggest: Boolean,
    syncValueAndText: Boolean,
    headerTemplate: String | Function,
    text: String,
    value: String,
    valuePrimitive: Boolean,
    virtual: Boolean | Object,

    // Events
    change: Function,
    close: Function,
    dataBound: Function,
    filtering: Function,
    open: Function,
    select: Function,
    cascade: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoMultiColumnComboBox/MultiColumnComboBoxProps.js